import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useToast } from 'src/hooks/useToast';

interface InviteInternalUserModalProps {
  open: boolean;
  data: string[]; // Brands list
  rolesObject: Record<string,any>;
  onClose: () => void;
  onInvite: (data: {
    email: string;
    roles: string[];
    allOrganizations: boolean;
    brands: string[];
  }) => void;
}

const InviteInternalUserModal: React.FC<InviteInternalUserModalProps> = ({
  open,
  onClose,
  onInvite,
  rolesObject,
  data,
}) => {
  const [email, setEmail] = useState('');
  const [roles, setRoles] = useState<string[]>([]);
  const [allOrganizations, setAllOrganizations] = useState<boolean>(false);
  const [brands, setBrands] = useState<string[]>([]);
  const { showSuccess, showError, showWarning } = useToast();

  const availableRoles = Object.keys(rolesObject).filter(key => rolesObject[key].type === 'internal') // Example roles
  const availableBrands = data; // Example brands
console.log('availableRoles',rolesObject)
  const handleInvite = () => {
    const lowerEmail = email.toLowerCase();
    const alpha = lowerEmail.match(/@swyft|@zoomsystems/)
    if (alpha === null) {
      showWarning(`To invite an external user, please use the Users tab.`);
    }
    else {
      return onInvite({ email, roles, allOrganizations, brands })
        .then(() => {
          // closePortal();
          // this.props.reloadData();
          showSuccess( `An email with invitation has been succesfully sent to ${lowerEmail}`);
          onClose();
        })
        .catch(() => {
          showError(`Something went wrong! Please contact administrator`);
          onClose();
        });
    } 
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle className="flex justify-between items-center bg-gray-100 text-gray-800">
        <span>Invite Internal User</span>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent className="space-y-4">
        {/* Email Input */}
        <TextField
          label="Email"
          type="email"
          placeholder="name@example.com"
          fullWidth
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          variant="outlined"
        />

        {/* User Roles Multi-Select */}
        <FormControl fullWidth>
          <InputLabel>User Role(s)</InputLabel>
          <Select
            multiple
            value={roles}
            onChange={(e) => setRoles(e.target.value as string[])}
            renderValue={(selected) => (
              <Box className="flex flex-wrap gap-1">
                {selected.map((role) => (
                  <Chip key={role} label={rolesObject[role].name} className="bg-orange-500 text-white" />
                ))}
              </Box>
            )}
          >
            {availableRoles.map((role) => (
              <MenuItem key={role} value={role}>
                {rolesObject[role].name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* All Organizations Toggle */}
        <FormControl fullWidth>
          <InputLabel>All Organizations</InputLabel>
          <Select
            value={allOrganizations ? 'True' : 'False'}
            onChange={(e) =>
              setAllOrganizations(e.target.value === 'True' ? true : false)
            }
          >
            <MenuItem value="True">True</MenuItem>
            <MenuItem value="False">False</MenuItem>
          </Select>
        </FormControl>

        {/* User Brands Multi-Select */}
        {!allOrganizations &&<FormControl fullWidth>
          <InputLabel>User Brand(s)</InputLabel>
          <Select
            multiple
            value={brands}
            onChange={(e) => setBrands(e.target.value as string[])}
            renderValue={(selected) => (
              <Box className="flex flex-wrap gap-1">
                {selected.map((brand) => (
                  <Chip key={brand} label={brand} className="bg-orange-500 text-white" />
                ))}
              </Box>
            )}
          >
            {availableBrands.map((brand) => (
              <MenuItem key={brand} value={brand}>
                {brand}
              </MenuItem>
            ))}
          </Select>
        </FormControl>}
      </DialogContent>
      <DialogActions className="bg-gray-100">
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={handleInvite}
          variant="contained"
          color="primary"
          //disabled={!email || roles.length === 0 || brands.length === 0}
          disabled={!email || roles.length === 0 || (!allOrganizations && brands.length === 0)}
        >
          Invite
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InviteInternalUserModal;
